import styled from 'styled-components'

export const Section = styled.div`
  margin-top: 20px;
  width: 100%;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #303030;
  margin: 0;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AddRootButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #0090d3;
  background-color: #ffffff;
  color: #0090d3;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const SetDefaultButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #10b981;
  background-color: #ffffff;
  color: #059669;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: #ecfdf5;
  }
`

export const DefaultSequenceBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #a7f3d0;
  background-color: #ecfdf5;
  color: #047857;
  font-size: 13px;
  font-weight: 600;
`

export const StageCard = styled.div<{ $completed?: boolean; $isChild?: boolean; $isDragging?: boolean }>`
  border: 1px solid ${(p) => (p.$completed ? '#b8bec7' : '#ddd')};
  border-radius: 8px;
  padding: 12px;
  margin: 8px 0;
  background-color: ${(p) => (p.$completed ? '#d7dbe0' : '#ffffff')};
  margin-left: ${(p) => (p.$isChild ? '24px' : '0px')};
  box-sizing: border-box;
  transition: box-shadow 0.2s ease;
  box-shadow: ${(p) => (p.$isDragging ? '0 8px 20px rgba(0, 0, 0, 0.15)' : 'none')};
  z-index: ${(p) => (p.$isDragging ? 99 : 1)};
`

export const StageCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const StageHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  padding: 2px;
  color: #666;

  &:active {
    cursor: grabbing;
  }
`

export const StageHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

export const StageTitleText = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StatusTag = styled.span<{ $variant: 'completed' | 'inProgress' | 'pending' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  background-color: ${(p) =>
    p.$variant === 'completed'
      ? '#4b5563'
      : p.$variant === 'inProgress'
        ? '#dbeafe'
        : '#f3f4f6'};
  color: ${(p) =>
    p.$variant === 'completed'
      ? '#ffffff'
      : p.$variant === 'inProgress'
        ? '#1d4ed8'
        : '#6b7280'};
  border: 1px solid
    ${(p) =>
      p.$variant === 'completed'
        ? '#4b5563'
        : p.$variant === 'inProgress'
          ? '#93c5fd'
          : '#d1d5db'};
`

export const CircularButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f8fafc;
    color: #0f172a;
  }
`

export const ActionIconButton = styled.button`
  border: none;
  background: transparent;
  color: #0090d3;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover:not(:disabled) {
    background-color: #f0f9ff;
  }
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`

export const CardFormBody = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #cbd5e1;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const FormGroup = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: ${(p) => (p.$fullWidth ? '1 / -1' : 'auto')};
`

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FormLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 13px;
  color: #1e293b;
  background-color: #f8fafc;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0090d3;
    background-color: #ffffff;
  }
`

export const StyledSelect = styled.select`
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 13px;
  color: #1e293b;
  background-color: #f8fafc;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0090d3;
    background-color: #ffffff;
  }
`

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 13px;
  color: #1e293b;
  background-color: #f8fafc;
  min-height: 80px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0090d3;
    background-color: #ffffff;
  }
`

export const FileUploadArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background-color: #f8fafc;
  cursor: pointer;
  font-size: 13px;
  color: #0090d3;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background-color: #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
`

export const FileActions = styled.div`
  display: flex;
  gap: 8px;
`

export const FileActionButton = styled.button`
  border: none;
  background: transparent;
  color: #0090d3;
  cursor: pointer;
  font-size: 12px;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`

export const CardFooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  gap: 12px;
`

export const AddSubStageButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #0090d3;
  background-color: #ffffff;
  color: #0090d3;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const SaveButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background-color: #0090d3;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #0077b3;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const EmptyMessage = styled.p`
  text-align: center;
  color: #64748b;
  font-size: 13px;
  padding: 16px 0;
`
